import { useCallback, useEffect, useRef, useState } from 'react'
import useAxiosRequests from '../hooks/useAxiosRequest'
import { loadStripe } from '@stripe/stripe-js'
import ExternalRoutes from '../config/ExternalRoutes'
import { useLocation, useNavigate } from 'react-router'
import LoadingPage from './LoadingPage'


export const PaymentMethodPage = () => {
  const { state } = useLocation();
  const { subscription } = state || {};
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
  const [clientSecret, setClientSecret] = useState(null)
  const { sendRequest } = useAxiosRequests()
  const hasFetchedRef = useRef(false);
  const navigate = useNavigate();
  const stripeDefaultPrice = process.env.REACT_APP_STRIPE_DEFAULT_PRICE;
  
  const fetchData = useCallback(async () => {
    try {
      const response = await sendRequest({
        method: 'POST',
        url: ExternalRoutes.subscription.payment,
        body: {
          'price_id': subscription?.subProductName || '0'
        }
      })
      if (response.status === 'success') {
        window.location.href = response.data;
      } else {
        navigate("/?canceled=true");
      }
    } catch (error) {
      console.log(error.message);
    }
  }, [sendRequest, subscription?.subPrice])

  useEffect(() => {
    if (!hasFetchedRef.current && !clientSecret) {
      hasFetchedRef.current = true;
      fetchData();
    }
  }, [])


  if (!clientSecret) return <LoadingPage />

  
}
